import React from 'react';
import './Dashboard.css';
import ReportStatusList from './widgets/reportStatus/ReportStatusList';
import ReportStatusErrorBoundary from './widgets/reportStatus/ReportStatusErrorBoundary';
import DashboardHeader from './widgets/dashboardHeader/DashboardHeader';

class Dashboard extends React.Component {
  render() {
    return (
      <div className="bx--grid Dashboard-grid">
        <DashboardHeader />
        <div className="Dashboard-spacing" />
        <ReportStatusErrorBoundary>
          <ReportStatusList />
        </ReportStatusErrorBoundary>
        <div className="Dashboard-spacing" />
      </div>
    );
  }
}

export default Dashboard;
